import React from 'react'
import axios from 'axios'
import { IndexLink, Link, withRouter } from 'react-router'
import RaisedButton from 'material-ui/RaisedButton'
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar'
import { connect } from 'react-redux'
import { loginFormVisible, logout } from '../../store/login'
import { registerFormVisible } from '../../store/register'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import AccountCircle from 'material-ui/svg-icons/action/account-circle'
import SearchIcon from 'material-ui/svg-icons/action/search'
import LocationIcon from 'material-ui/svg-icons/communication/location-on'
import { setCategories } from '../../store/category'
import {
    changeSearch,
    cityAutocomplete,
    leftSidebarVisible,
    getFilterString,
    getCategoryName,
    phraseAutocomplete
} from '../../store/search'
import CartIcon from '../../components/cart/CartIcon'
import GeneralProgressLoader from '../../components/progressbarr/GeneralProgressLoader'
import { ListItem, AutoComplete } from 'material-ui'
import { updateWalletItemsQty } from '../../store/walletItems'
import walletIco from '../fonts/WalletIcon_White.png'
import CategoriesSelect from '../../components/categories/CategoriesSelect'
import { getLocationCity } from '../../routes/Home/helpers/location'

class HeaderLayout extends React.Component {

    openLoginForm = () => {
        if (!this.state.isLogged) {
            this.loginForm(true);
        }
    };

    logout = () => {
        if (this.state.isLogged) {
            this.props.logout();
            this.props.router.push('/');
        }
    };

    openRegisterForm = () => {
        if (!this.state.isLogged) {
            this.registerForm(true);
        }
    };


    constructor(props) {
        super(props);
        this.loginForm = this.props.loginWindow;
        this.registerForm = this.props.registerWindow;
        this.state = {
            isLogged: this.props.isLogged,
            categories: this.props.categories,
            search: this.props.search,
            searchInputVisible: false,
            cities: [],
            walletItemsQty: this.props.walletItemsQty,
            isCollapsed: true,
            citySearchList: '',
            regionsSearchList: '',
            categoryName: this.props.categoryName,
            deals: []
        };

        if (this.state.isLogged) {
            this.props.updateWalletItemsQty();
        }
    };

    handleClickLocalDeal = (cid) => {
        this.props.changeSearch('', '', '');
        this.props.leftSidebarVisible(true);
        this.props.setCategories(this.state.categories, cid);
        this.setState({
            isCollapsed: true
        });
    };

    handleMenuClick = () => {
        this.setState({
            isCollapsed: true
        });
    };

    toggleMenuHandler = () => {
        this.setState({
            isCollapsed: !this.state.isCollapsed
        });
    };

    handleClickSearch = () => {
        this.setState({
            searchInputVisible: !this.state.searchInputVisible
        });
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isLogged: nextProps.isLogged,
            categories: nextProps.categories,
            search: nextProps.search,
            walletItemsQty: nextProps.walletItemsQty,
            citySearchList: nextProps.searchCityParams.join(', '),
            regionsSearchList: this.props.getFilterString(nextProps.filterRegions, nextProps.searchRegionParams),
            categoryName: this.props.categoryName
        });
    };

    handleSearchChangePhrase = (text, items) => {
        if (text.length >= 2) {
            this.props.phraseAutocomplete(text, this.state.search.city).then(resp => {                
                if (resp.data.promotions) {                    
                    this.setState({
                        deals: resp.data.promotions.map((item, idx) => {                            
                            return {
                                text: item.merchant.name + ' ' + item.title,
                                value: (
                                    <MenuItem
                                        data-merchantName={item.merchant.name}
                                        primaryText={item.merchant.name}
                                        style={{
                                            paddingRight: '15px',
                                            borderTop: idx === 0 ? 'none' : '1px lightgrey solid',
                                            width: '90%',
                                            marginLeft: '10px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                        secondaryText={
                                            <div style={{
                                                position: 'absolute',
                                                top: '15px',
                                                left: '80px',
                                                fontSize: '10px',
                                                color: 'grey'
                                            }}>
                                                {item.locations[0].address.city}
                                            </div>
                                        }
                                        leftIcon={
                                            <img src={item.images[0].url}
                                                 alt={item.title}
                                                 style={{ position: 'absolute', zIndex: 9999, left: '10px' }}
                                            />
                                        }
                                    />
                                )
                            }
                        })
                    })
                }
            })

        }

        const applySearch = items.find(item => item.text === text)
        this.props.changeSearch(applySearch ? applySearch.value.props["data-merchantName"]: text, this.state.search.city, this.state.search.region)

        if (applySearch) {
            setTimeout(() => {
                this.goToSearch()
            },1)
        }
    };

    handleSearchChangeCity = (city, items) => {        
        if (city.length >= 2) {
            this.props.cityAutocomplete(city).then(resp => {                
                let cities = resp.data.map((item, idx) => {
                    let city = item.city;
                    if (item.region.state) city += ', ' + item.region.state
                    return {
                        text: city,
                        value: (
                            <MenuItem
                                data-regionId={item.region.id}
                                data-state={item.region.state}
                                primaryText={<div>{city}</div>}
                                secondaryText={
                                    <div style={{
                                        position: 'absolute',
                                        top: '15px',
                                        left: '20px',
                                        fontSize: '10px',
                                        color: 'grey'
                                    }}>
                                        {item.region.name}
                                    </div>
                                }
                                style={{
                                    paddingRight: '10px',
                                    borderTop: idx === 0 ? 'none' : '1px lightgrey solid',
                                    width: '90%',
                                    marginLeft: '10px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    height: '50px'
                                }}

                            />
                        )
                    }
                });
                this.setState({ cities: cities });
            });
        }

        const applySearch = items.find(item => item.text === city)
        
        this.props.changeSearch(this.state.search.text, city, applySearch ? applySearch.value.props["data-regionId"]: 0);
        if (applySearch) {
            setTimeout(() => {
                this.goToSearch()
            },1)
        }
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.goToSearch();
        }
    };

    handleSearchIconClick = async () => {
      /*const city = await getLocationCity()

      if (city) {
        this.props.changeSearch(this.state.search.text, city)
      }*/

      this.goToSearch()
    }

    handleFilterButtonClick = () => {
        this.props.leftSidebarVisible(!this.props.leftSidebarShow);
    }

    goToSearch = () => {        
        if (this.state.search.text !== '' || this.state.search.city !== '') {
            let url = [];
            if (this.state.search.text !== '') {
                url.push('q=' + encodeURIComponent(this.state.search.text));
            }
            if (this.state.search.city !== '') {
                url.push('city=' + encodeURIComponent(this.state.search.city));
            }
            if(this.state.search.region !== 0 ) {
                url.push('regions[]=' + encodeURIComponent(this.state.search.region));
            }
            this.props.leftSidebarVisible(false);
            this.props.router.push('/deals?' + url.join('&'));
        } else {
            this.props.router.push('/deals');
        }
    };

    render() {
        return (
            <div>
                <div className={'top-header'} style={{ backgroundColor: '#333C8F', height: '70px' }}>
                    <div className="container">
                        <div className="row">
                            <Toolbar style={{ backgroundColor: '#333C8F', height: '70px' }}
                                     className="toolbar-top">
                                <ToolbarGroup className="left-actions"
                                              style={this.state.searchInputVisible ? { display: 'none' } : {}}>
                                    <div className="logo-wrp">
                                        <IndexLink to='/' className="menu-link">
                                            <img className="site-logo" src="/images/logo-new.png" alt="xookers" style={{'marginTop':'-20px'}}/>
                                        </IndexLink>
                                    </div>
                                </ToolbarGroup>
                                <ToolbarGroup
                                    className={this.state.searchInputVisible ? 'middle-actions' : 'middle-actions search-visible'}
                                    // style={{
                                    //     paddingTop: "30px"
                                    // }}
                                >
                                    <div className="first-group">
                                        <CategoriesSelect/>
                                        <div className="search-input-wrp">
                                            <ListItem
                                                className={'city-search-wrp'}
                                                style={{ padding: 0 }}
                                                primaryText={
                                                    <div className={'city-search'}>
                                                        <AutoComplete
                                                            className={'search-input'}
                                                            hintText="Search Xooker"
                                                            style={{
                                                                color: '#FFFFFF',
                                                                borderColor: '#FFFFFF',
                                                                backgroundColor: "#FFF",
                                                                borderRadius: "4px",
                                                                height: "40px",
                                                                marginTop: "30px",
                                                                width: '180px',
                                                                marginRight: '10px'
                                                            }}
                                                            listStyle={{ overflowX: 'hidden', width: '400px' }}
                                                            hintStyle={{
                                                                color: '#777',
                                                                fontSize: "14px",
                                                                left: "40px",
                                                                bottom: "7px",
                                                            }}
                                                            underlineShow={false}
                                                            inputStyle={{
                                                                color: '#000000',
                                                                paddingLeft: "40px",
                                                                paddingRight: "8px",
                                                                borderRadius: "4px",
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                width: '180px'
                                                            }}
                                                            searchText={this.state.search.text}
                                                            onUpdateInput={this.handleSearchChangePhrase}
                                                            onKeyPress={this.handleKeyPress}
                                                            filter={(searchText,item)=>{
                                                                return item.replace("'",'').toLowerCase().includes(searchText.replace("'",'').toLowerCase());                                                                
                                                            }}
                                                            dataSource={this.state.deals}
                                                            maxSearchResults={10}

                                                        />
                                                    </div>
                                                }
                                                rightIcon={
                                                    <SearchIcon
                                                        onClick={this.handleSearchIconClick}
                                                        className='search-city-ico'
                                                    />
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="search-input-wrp">

                                        <ListItem
                                            className={'city-search-wrp'}
                                            style={{ padding: 0 }}
                                            primaryText={
                                                <div className={'city-search'}>
                                                    <AutoComplete
                                                        className={'search-input'}
                                                        hintText="CITY"
                                                        style={{
                                                            color: '#FFFFFF',
                                                            borderColor: '#FFFFFF',
                                                            backgroundColor: "#FFF",
                                                            borderRadius: "4px",
                                                            height: "40px",
                                                            marginTop: "30px",
                                                            width: '180px',
                                                        }}
                                                        hintStyle={{
                                                            color: '#777',
                                                            fontSize: "14px",
                                                            left: "40px",
                                                            bottom: "7px"
                                                        }}
                                                        underlineShow={false}
                                                        inputStyle={{
                                                            color: '#000000',
                                                            paddingLeft: "40px",
                                                            paddingRight: "8px",
                                                            borderRadius: "4px",
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            width: '180px'
                                                        }}
                                                        searchText={this.state.search.city}
                                                        onUpdateInput={this.handleSearchChangeCity}
                                                        onKeyPress={this.handleKeyPress}
                                                        filter={AutoComplete.fuzzyFilter}
                                                        dataSource={this.state.cities}
                                                        maxSearchResults={10}
                                                    />
                                                </div>
                                            }
                                            rightIcon={
                                                <LocationIcon
                                                    className='search-city-ico'
                                                    color="#000000"
                                                    onClick={this.handleSearchIconClick}
                                                    style={{}}
                                                />
                                            }
                                        />
                                    </div>
                                </ToolbarGroup>
                                <ToolbarGroup className="right-actions" style={{ alignItems: 'flex-end' }}>
                                    <div className="mobile-none menu-link menu-item f-upper fw-700"
                                         style={this.state.isLogged ? { display: 'none' } : {}}
                                         onClick={this.openRegisterForm}>Sign Up
                                    </div>
                                    <IndexLink to='/help'
                                               className="d-none d-lg-block menu-link menu-item f-upper fw-700"
                                               activeClassName='page-layout__nav-item--active'>Help</IndexLink>

                                    <CartIcon/>
                                    <Link to={'/wallet'} className="wallet-wrapper"
                                          style={!this.state.isLogged ? { display: 'none' } : {}}>
                                        <span className="wallet-ico"><img src={walletIco} alt="wallet"/></span>
                                        <span className="wallet-num product-number"
                                              style={this.state.walletItemsQty === 0 ? { display: 'none' } : {}}>
                                            {this.state.walletItemsQty}
                                        </span>
                                    </Link>
                                </ToolbarGroup>
                            </Toolbar>
                        </div>
                    </div>
                </div>


                <div style={{ backgroundColor: '#DD3830' }}
                     className="toolbar-bottom">
                    <div className="container">
                        <nav className="navbar navbar-expand-lg navbar-dark main-menu">
                            <button onClick={this.toggleMenuHandler} className="navbar-toggler" type="button"
                                    data-toggle="collapse"
                                    data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon">
                              <i className="material-icons">&#xE5D2;</i>
                            </span>
                            </button>
                            <span className={'search-btn d-md-none'} onClick={this.handleClickSearch}>
                        <i className="material-icons">&#xE8B6;</i>
                      </span>
                            <div
                                className={this.state.isCollapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show'}
                                id="navbarNavDropdown">
                                <ul className="navbar-nav">
                                    <li className="nav-item active" onClick={this.handleMenuClick}>
                                        <IndexLink to='/' className="menu-link"
                                                   activeClassName='page-layout__nav-item--active'>Home</IndexLink>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <IndexLink to='/deals'
                                                   className="menu-link dropdown-toggle" id="navbarDropdownMenuLink"
                                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Local Deals
                                        </IndexLink>
                                        <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                            {this.state.categories.map((i, inx) => {
                                                return (<IndexLink className={'dropdown-item'} key={inx}
                                                                   to={i.id ? '/deals/?' + i.url : '/deals'}
                                                                   onClick={() => this.handleClickLocalDeal(i.id)}>{i.name}</IndexLink>);
                                            })}
                                        </div>
                                    </li>
                                    <li className="nav-item" onClick={this.handleMenuClick}>
                                        <IndexLink to='/contact-us' className="menu-link"
                                                   activeClassName='page-layout__nav-item--active'>Contact</IndexLink>
                                    </li>
                                    <li className="nav-item" onClick={this.handleMenuClick}>
                                        <div onClick={this.openLoginForm}
                                             style={this.state.isLogged ? { display: 'none' } : {}}
                                             className="menu-link sign-in">Sign In
                                        </div>
                                    </li>
                                    <li className="nav-item" onClick={this.handleMenuClick}>
                                        <div className="d-lg-none menu-link menu-item"
                                             style={this.state.isLogged ? { display: 'none' } : {}}
                                             onClick={this.openRegisterForm}>Sign Up
                                        </div>
                                    </li>
                                    <li className="nav-item" onClick={this.handleMenuClick}>
                                        <IndexLink to='/help' className="d-lg-none menu-link menu-item"
                                                   activeClassName='page-layout__nav-item--active'>Help</IndexLink>
                                    </li>
                                    <li className={"mobile-none user"}
                                        style={!this.state.isLogged ? { display: 'none' } : {}}>
                                        <IconMenu className={"user-icon"}
                                                  iconButtonElement={<IconButton iconStyle={{ width: 35, height: 35 }}>
                                                      <AccountCircle color='#FFFFFF'/>
                                                  </IconButton>}
                                                  anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                                                  targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                                        >
                                            <MenuItem className="account-info" to='/account-info'
                                                      primaryText={<Link to='/account-info' className="menu-link">Account
                                                          Info</Link>}/>
                                            <MenuItem className="logout-btn" onClick={this.logout}
                                                      primaryText="Logout"/>
                                        </IconMenu>
                                    </li>

                                    <li className="nav-item" style={!this.state.isLogged ? { display: 'none' } : {}}
                                        onClick={this.handleMenuClick}>
                                        <IndexLink to='/account-info' className="d-lg-none menu-link menu-item"
                                                   activeClassName='page-layout__nav-item--active'>Account
                                            Info</IndexLink>
                                    </li>
                                    <li className="nav-item" style={!this.state.isLogged ? { display: 'none' } : {}}
                                        onClick={this.handleMenuClick}>
                                        <div className="d-lg-none menu-link menu-item"
                                             onClick={this.logout}>Logout
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
                <div style={{ backgroundColor: '#fff' }} className={'hidden-md-up filter-block'}>
                    <div className={'container xs-hidden'}>
                        <div className="filterby-btn clearfix">
                            <RaisedButton
                                className={'align-baseline'}
                                onClick={this.handleFilterButtonClick}
                                label={'Filter by'}
                                style={{ float: "right", boxShadow: "none", border: "none" }}
                                icon={!this.props.leftSidebarShow ? <i className="material-icons">&#xE313;</i> :
                                    <i className="material-icons">&#xE316;</i>}
                            />
                        </div>
                        <div className="filter-parts">
                            {this.state.citySearchList ? (
                                <div className="filter-cities">
                                    <span className={'search-res-text'}>Cities: </span>
                                    <span>  {this.state.citySearchList}</span>
                                </div>) : ''}
                            {this.state.regionsSearchList ? (
                                <div className="filter-regions">
                                    <span className={'search-res-text'}>Regions: </span>
                                    <span> {this.state.regionsSearchList}</span>
                                </div>) : ''}
                            {this.state.categoryName ? (
                                <div className="filter-category">
                                    <span className={'search-res-text'}>Category: </span>
                                    <span>  {this.state.categoryName}</span>
                                </div>) : ''}
                        </div>
                    </div>
                </div>  
                <GeneralProgressLoader/>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        isLogged: state.token ? true : false,
        categories: state.categories,
        search: state.search,
        walletItemsQty: state.walletItemsQty,
        leftSidebarShow: state.leftSidebarShow,
        searchCityParams: state.searchCityParams,
        searchRegionParams: state.searchRegionParams,
        filterCities: state.filterCities,
        filterRegions: state.filterRegions,
        categoryName: state.categoryName,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        loginWindow: (value) => dispatch(loginFormVisible(value)),
        registerWindow: (value) => dispatch(registerFormVisible(value)),
        leftSidebarVisible: (value) => dispatch(leftSidebarVisible(value)),
        changeSearch: (text, city, region) => dispatch(changeSearch(text, city, region)),
        logout: (value) => dispatch(logout()),
        setCategories: (categories, cid) => dispatch(setCategories(categories, cid)),
        cityAutocomplete: (city) => dispatch(cityAutocomplete(city)),
        updateWalletItemsQty: () => dispatch(updateWalletItemsQty()),
        getFilterString: (ItemsList, selectedItems) => getFilterString(ItemsList, selectedItems),
        phraseAutocomplete: (text,city) => dispatch(phraseAutocomplete(text,city)),
    };
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(HeaderLayout))



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/HeaderLayout.js